import { usePayment } from '@src/api/payment-api/payments-api'
import { useGetActivePersonLoan } from '@src/api/person-api'
import { LastPaymentCard, PageSpinner, PaymentsInfo } from '@src/components'
import { getDaysToNextPayment } from '@src/services/Formatter'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { Box, Container, Typography, Divider, Grid } from '@mui/material'
import ActionsPayment from './components/ActionsPayment'
import NotificationContainer from './components/NotificationContainer'
import { getLoanLabel } from '../../services/loanUtils'; 

const Accueil = () => {
  const { t } = useTranslation()
  const { id } = useParams<{ id?: string }>()
  const navigate = useNavigate()

  const [selectedPayment, isLoading] = usePayment(id)
  const [activeLoan] = useGetActivePersonLoan(id)
  const { closestPayment, lastPayment } = selectedPayment ?? {}
  const loanTypeLabel = activeLoan ? getLoanLabel(activeLoan.customerTypeId,t) : `${t('loan.obsolete')}`;
  const isManualPayment = closestPayment?.IsManualPmt ?? false;
  const getDisplayDaysToNextPayment = (nextPaymentDateUTC: string): string => {
    const daysDifference = getDaysToNextPayment(nextPaymentDateUTC)
    const daysMessage = daysDifference === 0 ? t('payment.today') : `${daysDifference} ${t('payment.days')}`
    return daysMessage
  }

  const daysToNextPayment = closestPayment ? getDaysToNextPayment(closestPayment.plannedOnDateUTC) : Number.MAX_SAFE_INTEGER;

    const isMoveButtonVisible = activeLoan
    ? parseFloat(activeLoan?.lateAmountWithInterest?.toString() || '0') === 0 && daysToNextPayment <= 14
    : false;

  const displayDaysToNextPayment = closestPayment ? getDisplayDaysToNextPayment(closestPayment.plannedOnDateUTC) : ''

  const onMovePayment = () =>  navigate(id ? `/move-payement/${id}` : '/move-payement')
  const onGoToLoanStatus = () => navigate(id ? `/loan-status/${id}` : '/loan-status')
  const onAddPayment = () => navigate(id ? `/add-payment/${id}` : '/add-payment')
  const onGoToCalendar = () => navigate(id ? `/calendar/${id}` : '/calendar')
  if (isLoading  ) return <PageSpinner isLoading={true} />

  const NotificationContainerProps = {
    isManualPayment: isManualPayment,
    lateAmountWithInterest: activeLoan?.lateAmountWithInterest?.toString() ?? '0',
    selectedPayment: closestPayment,
    goToAddPayment: onAddPayment,
  }

  const ActionsPaymentProps = {
    isMoveButtonVisible: isMoveButtonVisible,
    disableAddPayment: activeLoan?.isCodemandeur || activeLoan?.isClosed || false, 
    disableMovePayment: activeLoan?.isCodemandeur || activeLoan?.isClosed || false, 
    disableCalendar: activeLoan?.isClosed || false, 
    onMovePayment: onMovePayment,
    onAddPayment: onAddPayment,
    onGoToLoanStatus,
    onGoToCalendar:  onGoToCalendar,
  }

  const PaymentsInfoProps = {
    payments: closestPayment ? [closestPayment] : [],
    closedNextPayment: activeLoan?.isClosed || false,
  }
  const styles = {
    container: {
      padding: { xs: '0 1px', sm: '0 20px', mb: 2 },
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
    },
    typography : {
      color: 'white',
      fontWeight: '200',
      fontSize: { xs: '1.5rem', sm: '1.5rem', md: '1.5rem', lg: '1.2rem' },
    }
  }

  return (
    <>
    {!activeLoan?.isClosed  && <Box sx={{ mb: 2 }}>
        <Container>
          <Box sx={styles.container}>
            <NotificationContainer {...NotificationContainerProps} />
          </Box>
        </Container>
        { isManualPayment || parseFloat(activeLoan?.lateAmountWithInterest?.toString()|| '0') > 0  && <Divider sx={{ bgcolor: 'grey.900',mb:3 }} />}
      </Box>}
      {id && (
        <>
          <Box sx={{ mb: 2 }}>
            <Container>
            <Box sx={styles.container}>
                <Typography
                  sx={styles.typography}
                >
                  {` ${loanTypeLabel} : ${id}`}
                </Typography>
              {activeLoan?.isCodemandeur && <Typography sx={{ color: 'grey.500', fontWeight: '200', fontSize: '1rem' }}>{t('payment.coBorrower')}
                </Typography>}  
              </Box>
            </Container>
          </Box>
          <Divider sx={{ bgcolor: 'grey.900', mb: 3 }} />
        </>
      )}
      <Container component="main" sx={{ flexGrow: 1 }}>
        <Grid container>
          <Grid size={{ xs: 12, md: 9, lg: 9 }}>
            <Box sx={{ padding: { xs: '0 1px', sm: '0 20px' }, boxSizing: 'border-box' }}>
              <PaymentsInfo {...PaymentsInfoProps} daysToNextPayment={displayDaysToNextPayment} />

              <ActionsPayment {...ActionsPaymentProps} />

              <LastPaymentCard selectedPayment={lastPayment} />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  )
}
export default Accueil
